import { Box } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import AcceptChangesButton from './AcceptChangesButton';
import CommentIconComponent from './CommentIcon';
import Overlay from './Overlay';
import { CommentEntry, OverlayEntry } from './contentDiffComparisonTypes';

interface ContentDiffCommentOverlaysProps {
  overlayPositions: OverlayEntry[];
  sectionData: Array<{
    sectionId: string;
    hasChanges: boolean;
    isAccepted: boolean;
  }>;
  tone: keyof typeof Palette;
  currentUser?: string;
  onReply?: (conversationId: string, message: string) => void;
  onAcceptChanges?: (sectionId: string) => void;
}

const ContentDiffCommentOverlays: React.FC<ContentDiffCommentOverlaysProps> = ({
  overlayPositions,
  sectionData,
  tone,
  currentUser,
  onReply,
  onAcceptChanges,
}) => {
  if (!overlayPositions.length) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 20,
      }}
    >
      {overlayPositions.map(({ comment, top, right }) => {
        const sectionInfo = sectionData.find((s) => s.sectionId === comment.sectionId);
        const hasChanges = sectionInfo?.hasChanges || false;
        const isAccepted = sectionInfo?.isAccepted || false;

        return (
          <Overlay key={comment.conversationId} position={{ top, right }}>
            <>
              {hasChanges && !isAccepted && onAcceptChanges && (
                <AcceptChangesButton onAccept={() => onAcceptChanges(comment.sectionId)} />
              )}
              <CommentIconComponent
                conversation={comment}
                tone={tone}
                currentUser={currentUser}
                onReply={onReply}
              />
            </>
          </Overlay>
        );
      })}
    </Box>
  );
};

export default ContentDiffCommentOverlays;
